var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSignOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.796 9.46967C16.0888 9.76256 16.0888 10.2374 15.796 10.5303L12.796 13.5303C12.5031 13.8232 12.0282 13.8232 11.7353 13.5303C11.4424 13.2374 11.4424 12.7626 11.7353 12.4697L13.455 10.75H8.26562C7.85141 10.75 7.51562 10.4142 7.51562 10C7.51562 9.58579 7.85141 9.25 8.26562 9.25H13.455L11.7353 7.53033C11.4424 7.23744 11.4424 6.76256 11.7353 6.46967C12.0282 6.17678 12.5031 6.17678 12.796 6.46967L15.796 9.46967Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.26562 1.75C2.57527 1.75 2.01562 2.30964 2.01562 3V17C2.01562 17.6904 2.57527 18.25 3.26562 18.25H13.2656C13.956 18.25 14.5156 17.6904 14.5156 17V16C14.5156 15.5858 14.8514 15.25 15.2656 15.25C15.6798 15.25 16.0156 15.5858 16.0156 16V17C16.0156 18.5188 14.7844 19.75 13.2656 19.75H3.26562C1.74684 19.75 0.515625 18.5188 0.515625 17V3C0.515625 1.48122 1.74684 0.25 3.26562 0.25H13.2656C14.7844 0.25 16.0156 1.48122 16.0156 3V4C16.0156 4.41421 15.6798 4.75 15.2656 4.75C14.8514 4.75 14.5156 4.41421 14.5156 4V3C14.5156 2.30964 13.956 1.75 13.2656 1.75H3.26562Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignOut);
export default __webpack_public_path__ + "static/media/icon-sign-out.bf105bf01546bc3b6bedacd6fe9b9bfb.svg";
export { ForwardRef as ReactComponent };